import React from "react";
import {
  List,
  Edit,
  Create,
  Datagrid,
  TextField,
  EditButton,
  DisabledInput,
  SimpleForm,
  TextInput,
  LongTextInput,
  required
} from "react-admin";

export const OtelList = (props: any) => (
  <List {...props} title="Oteller">
    <Datagrid>
      <TextField source="id" />
      <TextField source="otel_ismi" />
      <EditButton />
    </Datagrid>
  </List>
);

export const OtelEdit = (props: any) => (
  <Edit {...props}>
    <SimpleForm redirect="list">
      <DisabledInput source="id" />
      <TextInput validate={required()} source="otel_ismi" />
      <LongTextInput validate={required()} label="Adres" source="adres" />
    </SimpleForm>
  </Edit>
);

export const OtelCreate = (props: any) => (
  <Create {...props}>
    <SimpleForm redirect="list">
      <TextInput validate={required()} label="Otel İsmi" source="otel_ismi" />
      <LongTextInput validate={required()} label="Adres" source="adres" />
    </SimpleForm>
  </Create>
);
